import { Money } from '@betterment/core';
import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { nameAndImage } from '../sharedSchemas';

export const target = Yup.object({
  amount: Yup.mixed<Money>().optional(),
  month: Yup.string().required(),
  year: Yup.string().required(),
});

export const MAJOR_PURCHASE_FLOW_CONFIG = createConfig({
  nameAndImage: {
    schema: nameAndImage,
    dependencies: Yup.object({}),
  },
  target: {
    schema: target,
    dependencies: Yup.object({
      nameAndImage,
    }),
  },
});

export const { FlowProvider, useStep: useMajorPurchaseStep } = createFlowContext(MAJOR_PURCHASE_FLOW_CONFIG);

export const MajorPurchaseFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <FlowProvider flowId={flowId}>
      <Outlet />
    </FlowProvider>
  );
};
